module.exports = __webpack_public_path__ + "img/content@3x.88ccb532.png";